import { create } from 'zustand';

type Store = {
  isModalOpen: boolean;
  stickyHeaderPresent: boolean;
  setIsModalOpen: (m: boolean) => void;
  setStickyHeaderPresent: (shp: boolean) => void;
};

export const useOfferDetailsModalStore = create<Store>()((set) => ({
  isModalOpen: false,
  stickyHeaderPresent: false,
  setIsModalOpen: (m: boolean) => set(() => ({ isModalOpen: m })),
  setStickyHeaderPresent: (shp: boolean) => set(() => ({ stickyHeaderPresent: shp })),
}));
